import { createFileRoute, Navigate } from "@tanstack/react-router"
import { StoreConfigStep } from "@/features/project-editor/upload-flow/components/StoreConfigStep"
import { usePermissions } from "@/hooks/usePermissions"

export const Route = createFileRoute("/(authenticated)/projects/new/$projectId/configure")({
  component: ConfigureRouteComponent,
})

function ConfigureRouteComponent() {
  const { projectId } = Route.useParams()

  // Access control: Only users with project:update permission can configure
  const { hasPermission, isLoading } = usePermissions()

  // Wait for permissions to load before checking access
  if (isLoading) {
    return null
  }

  const canConfigure = hasPermission("project", "update").allowed

  if (!canConfigure) {
    return <Navigate to="/projects" />
  }

  return <StoreConfigStep projectId={projectId} />
}
